module.exports = __webpack_public_path__ + "2552d97429f2034df8e99fa26fb761c2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/font/OpenSans-Regular.svg
 ** module id = 915
 ** module chunks = 9
 **/